import { Box } from '@mui/material';
import { DEFAULT_FORMAT, money } from '../lib/format';

/** An amount (decimal string from the API) in `currency`, tabular, never wrapping. */
export function Money({
  value,
  currency = DEFAULT_FORMAT.currencyCode,
  decimals = DEFAULT_FORMAT.currencyDecimals,
  strong,
}: {
  value: string | number | null | undefined;
  currency?: string;
  decimals?: number;
  strong?: boolean;
}) {
  return (
    <Box
      component="span"
      className="tabular"
      sx={{ whiteSpace: 'nowrap', fontWeight: strong ? 650 : undefined }}
    >
      {money(value, { ...DEFAULT_FORMAT, currencyCode: currency, currencyDecimals: decimals })}
    </Box>
  );
}
